import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { MutationKeys } from "constants/mutation-keys";
import { ToastContent, getToastContent } from "constants/toasts";
import { ApiManager } from "services/api";
import { ToastVariant, ToastsActions } from "store/features/toasts";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
const setOpenWidgetTeam = async ({ integrationId, teamId }: any) => {
  const { error, result } = await ApiManager.integrationsApi.setOpenWidgetTeam(integrationId, teamId);
  if (error) {
    throw error;
  }
  return result;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useSetOpenWidgetTeam = ({ onError }: { onError: () => void }) => {
  const dispatch = useDispatch();

  return useMutation({
    mutationKey: [MutationKeys.OpenWidget, "setTeam"],
    mutationFn: setOpenWidgetTeam,
    onSuccess: () => {
      dispatch(
        ToastsActions.createToast({
          variant: ToastVariant.Success,
          content: getToastContent(ToastContent.OPENWIDGET_UPDATE_SUCCESS),
        })
      );
    },
    onError: () => {
      if (onError) {
        onError();
      }
      dispatch(
        ToastsActions.createToast({
          variant: ToastVariant.Error,
          content: getToastContent(ToastContent.OPENWIDGET_UPDATE_FAILURE),
        })
      );
    },
  });
};
